<template>
  <form style="position: relative">
    <div style="position:absolute; top: 10px; right: 10px;">
    <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>HTML Block</h2>
     <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
    <div class="divider">
      <label class="contentLabel" for="htmlContent">{{ $t('Add.Html.Content') }}</label>
      <codemirror
        class="codeEditor"
        v-model="contents"
        placeholder="Code gose here..."
        :extensions="extensions"
        style="margin-top: 5px; height: 200px"
      />
      <button @click.prevent="openModal = true"><span class="material-symbols-outlined">fullscreen</span></button>
      <EditorModal 
        v-if="openModal" :code=contents
        :isOpen="openModal" 
        :editorMode="'html'"
        @close="openModal = false"
        @updateCode="updateContents"
        />
    </div>
    <NameProp :sharedData="sharedData" />
    <ClassNamesProp :sharedData="sharedData" />
    </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Style') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
    <div v-show="isSectionActive('style')" class="accordion-content">
    <FontSizeProp :sharedData="sharedData" />
    <FontFamilyProp :sharedData="sharedData" />
    <TextColorProp :sharedData="sharedData" />
    <BackgroundColorProp :sharedData="sharedData" />
    </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>Positioning</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
    </div>
    <div v-show="isSectionActive('positioning')" class="accordion-content">
    <AlignmentProp :sharedData="sharedData" /> 
    <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
  </form>
</template>

<script>
import {Codemirror} from 'vue-codemirror';
import { html } from "@codemirror/lang-html";
import { EditorView } from '@codemirror/view';
import EditorModal from '../Reusables/EditorModal.vue'
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import TextColorProp from './AddProps/TextColorProp.vue';
import BackgroundColorProp from './AddProps/BackgroundColorProp.vue';
import FontSizeProp from './AddProps/FontSizeProp.vue';
import FontFamilyProp from './AddProps/FontFamilyProp.vue';
import AlignmentProp from './AddProps/AlignmentProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';

export default {
  name: 'AddHtml',
  components: {
    Codemirror, EditorModal, PaddingProp,
     NameProp, ClassNamesProp, TextColorProp, BackgroundColorProp, FontSizeProp,
      FontFamilyProp, AlignmentProp, CopyBlock
  },
  props: ['sharedData'],
  data() {
    return {
      extensions: [html(),  EditorView.lineWrapping],
      //activeSections: ['main'], // Default aktivierter Reiter
      openModal: false,
    };
  },
  computed: {
    contents: {
      get() {
        return this.sharedData?.data?.props?.contents || '';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.contents = value;
      },
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
  },
  methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
        this.activeSections = this.activeSections.filter(s => s !== section);
      } else {
        // Abschnitt hinzufügen
        this.activeSections.push(section);
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section);
    },
    updateContents(contents){
      this.sharedData.data.props.contents = contents
    }
    
  },
};
</script>

 <style scoped>
 @import '../../styles/addComponents.css';

 button{
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: right;
  margin-top: 10px;
 }

 button:focus {
  outline: none;
}



 </style> 

 